import { await1kke5zj2piplv as await_0 } from '../../../../../reactive/com/lightningkite/reactive/context/DependencyChangeListener.mjs';
import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  get_dialogStackleaqvayyucjw as get_dialogStack,
  get_viewIsWide3s4g60a9e0192 as get_viewIsWide,
} from '../components/nav/crowpay.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { _ServerFile___get_location__impl__ddyqaq3o0wsfuapqiy2 as _ServerFile___get_location__impl__ddyqaq } from '../../../../../lightning-server-shared/com/lightningkite/lightningserver/files/ServerFile.mjs';
import { Frame1e7t2kcdb3wu7 as Frame } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { ZoomableImageView2th1eo3ejqzvg as ZoomableImageView } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ZoomableImageView.mjs';
import {
  ImageScaleType_Fit_getInstanceowdhgt1q4kgg as ImageScaleType_Fit_getInstance,
  ImageRemote256pcav1ipbca as ImageRemote,
  times2ukvaf6yk96p2 as times,
  Align_Stretch_getInstancecei5ndh62f1w as Align_Stretch_getInstance,
  Align_Center_getInstance2f7zhxjck1drv as Align_Center_getInstance,
  Align_Start_getInstance25tw14h3otx5g as Align_Start_getInstance,
  Companion_getInstance2a03ktg5l3ejl as Companion_getInstance,
  Align_End_getInstance1wccjuzcldlk8 as Align_End_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import { KMutableProperty025txtn5b59pq1 as KMutableProperty0 } from '../../../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { startsWith26w8qjqapeeq6 as startsWith } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/stringsCode.mjs';
import { reactiveScope1fcalsbdr0hgb as reactiveScope } from '../../../../../reactive/com/lightningkite/reactive/context/ReactiveContext.mjs';
import {
  get_centered1xfu6or5nc0lq as get_centered,
  get_expanding10cuv3ua9vajx as get_expanding,
  get_atTopEnd21ub47e8cwtv6 as get_atTopEnd,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  shownWhenxgf1ujy6rmvr as shownWhen,
  align1ejncrrer3meh as align,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.commonHtml.mjs';
import { ExternalLink3fl954ixvn5zt as ExternalLink } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ExternalLink.commonHtml.mjs';
import { h33vrlzi8yr34xu as h3 } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/shortcuts.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import { ImagePreviewSemantic_getInstance2vyufepdkqnqf as ImagePreviewSemantic_getInstance } from '../theming/files.mjs';
import {
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
  CardSemantic_getInstance24h7hf3qltxfl as CardSemantic_getInstance,
  ButtonSemantic_getInstance2exl8jbak13ac as ButtonSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { Recycler21f097l2zl8cft as Recycler2 } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/Recycler2.mjs';
import { RecyclerViewPagingPlacer1ttl0zmemv9d1 as RecyclerViewPagingPlacer } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/RecyclerViewPagingPlacer.mjs';
import { Companion_instanceyb6grjkdzphm as Companion_instance } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/RecyclerViewData.mjs';
import { Companion_instance28p2tgglllsme as Companion_instance_0 } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/RecyclerViewRendererSet.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import { icon1sxjaie5w1apt as icon } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/l2/shortstuff.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { Companion_instance2rgq1hlpwff0j as Companion_instance_1 } from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.mjs';
import { get_usesTouchscreengqckifr7xvdp as get_usesTouchscreen } from '../../../../../kiteui-library/com/lightningkite/kiteui/Platform.js.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { resize3py5p2yrjp6p7 as resize } from '../../utils/utils.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.yic_1.odd_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.yic_1.odd_1.gah((tmp$ret$0 - 1 | 0) % $this.zic_1.aid_1.p1() | 0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  // Inline function 'com.lightningkite.reactive.context.invoke' call
  var this_0 = $this.bid_1.odd_1;
  var tmp = await_0(this_0, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp$ret$0 = tmp;
  var tmp_0 = $this.bid_1.odd_1.gah((tmp$ret$0 + 1 | 0) % $this.cid_1.aid_1.p1() | 0, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return Unit_instance;
}
var ImagePreview$render$slambdaClass;
function ImagePreview$render$slambda() {
  if (ImagePreview$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ImagePreview$render$slambdaClass = $;
  }
  return ImagePreview$render$slambdaClass;
}
function ImagePreview$render$slambda_0() {
  var i = new (ImagePreview$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function ImagePreview$render$lambda(it) {
  return _ServerFile___get_location__impl__ddyqaq(it.g93());
}
function ImagePreview$render$lambda_0($this$single, attachment) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())($this$single.pc());
  var tmp0_elvis_lhs = $this$single.cbb_1;
  var p = tmp0_elvis_lhs == null ? $this$single : tmp0_elvis_lhs;
  $this$single.ebb(p, view);
  // Inline function 'com.lightningkite.kiteui.views.direct.zoomableImage' call
  // Inline function 'kotlin.apply' call
  var this_0 = new (ZoomableImageView())(view);
  this_0.pda(ImageScaleType_Fit_getInstance());
  var tmp0 = this_0.odb_1;
  var tmp = KMutableProperty0();
  var tmp_0 = Frame$_get_shown_$ref_dnks5k(tmp0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_1 = getPropertyCallableRef('shown', 0, tmp, tmp_0, Frame$_set_shown_$ref_s2otf0(tmp0));
  reactiveScope(view, ($this$reactiveScope) => {
    var tmp$ret$0 = startsWith($this$reactiveScope.baj(attachment).f93(), 'image');
    this_1.set(tmp$ret$0);
    return Unit_instance;
  });
  var tmp_1 = KMutableProperty0();
  var tmp_2 = ZoomableImageView$_get_source_$ref_9pqjqo(this_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_2 = getPropertyCallableRef('source', 0, tmp_1, tmp_2, ZoomableImageView$_set_source_$ref_orz4vw(this_0));
  reactiveScope(view, ($this$reactiveScope) => {
    // Inline function 'kotlin.let' call
    var it = $this$reactiveScope.baj(attachment);
    var tmp;
    if (startsWith(it.f93(), 'image')) {
      // Inline function 'kotlin.let' call
      var p0 = _ServerFile___get_location__impl__ddyqaq(it.g93());
      tmp = new (ImageRemote())(p0);
    } else {
      tmp = null;
    }
    var tmp$ret$6 = tmp;
    this_2.set(tmp$ret$6);
    return Unit_instance;
  });
  this_0.zba();
  var tmp_3 = get_centered(view);
  var tmp_4 = view.ibb(tmp_3, shownWhen(view, false, ($this$shownWhen) => !startsWith($this$shownWhen.baj(attachment).f93(), 'image')));
  // Inline function 'com.lightningkite.kiteui.views.direct.externalLink' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (ExternalLink())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  h3(view_0, 'Open File');
  var tmp_5 = KMutableProperty0();
  var tmp_6 = ExternalLink$_get_to_$ref_jqs3qa(view_0);
  // Inline function 'com.lightningkite.reactive.context.CoroutineScopeHelpers.invoke' call
  var this_3 = getPropertyCallableRef('to', 0, tmp_5, tmp_6, ExternalLink$_set_to_$ref_l7iod2(view_0));
  reactiveScope(view_0, ($this$reactiveScope) => {
    var tmp$ret$12 = _ServerFile___get_location__impl__ddyqaq($this$reactiveScope.baj(attachment).g93());
    this_3.set(tmp$ret$12);
    return Unit_instance;
  });
  // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.newTab' call
  var tmp0_0 = view_0.tb5_1.zb3_1;
  // Inline function 'com.lightningkite.kiteui.views.target' call
  var value = true ? '_blank' : '_self';
  tmp0_0.ib7_1.target = value;
  view.fbb(p_0, view_0);
  view.jbb(tmp_4, view_0);
  $this$single.fbb(p, view);
  return view;
}
function Frame$_get_shown_$ref_dnks5k(p0) {
  return () => p0.wb8();
}
function Frame$_set_shown_$ref_s2otf0(p0) {
  return (_this__u8e3s4) => {
    p0.hb7(_this__u8e3s4);
    return Unit_instance;
  };
}
function ZoomableImageView$_get_source_$ref_9pqjqo(p0) {
  return () => p0.i2i();
}
function ZoomableImageView$_set_source_$ref_orz4vw(p0) {
  return (_this__u8e3s4) => {
    p0.oda(_this__u8e3s4);
    return Unit_instance;
  };
}
function ExternalLink$_get_to_$ref_jqs3qa(p0) {
  return () => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    var tmp = p0.tb5_1.zb3_1.ib7_1.href;
    return (!(tmp == null) ? typeof tmp === 'string' : false) ? tmp : null;
  };
}
function ExternalLink$_set_to_$ref_l7iod2(p0) {
  return (_this__u8e3s4) => {
    // Inline function 'com.lightningkite.kiteui.views.direct.ExternalLink.to' call
    // Inline function 'com.lightningkite.kiteui.views.href' call
    p0.tb5_1.zb3_1.ib7_1.href = _this__u8e3s4;
    return Unit_instance;
  };
}
var ImagePreview$render$slambdaClass_0;
function ImagePreview$render$slambda_1() {
  if (ImagePreview$render$slambdaClass_0 === VOID) {
    class $ {
      constructor($$this$apply, this$0) {
        this.yic_1 = $$this$apply;
        this.zic_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ImagePreview$render$slambdaClass_0 = $;
  }
  return ImagePreview$render$slambdaClass_0;
}
function ImagePreview$render$slambda_2($$this$apply, this$0) {
  var i = new (ImagePreview$render$slambda_1())($$this$apply, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ImagePreview$render$slambdaClass_1;
function ImagePreview$render$slambda_3() {
  if (ImagePreview$render$slambdaClass_1 === VOID) {
    class $ {
      constructor($$this$apply, this$0) {
        this.bid_1 = $$this$apply;
        this.cid_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ImagePreview$render$slambdaClass_1 = $;
  }
  return ImagePreview$render$slambdaClass_1;
}
function ImagePreview$render$slambda_4($$this$apply, this$0) {
  var i = new (ImagePreview$render$slambda_3())($$this$apply, this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ImagePreview$render$slambdaClass_2;
function ImagePreview$render$slambda_5() {
  if (ImagePreview$render$slambdaClass_2 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ImagePreview$render$slambdaClass_2 = $;
  }
  return ImagePreview$render$slambdaClass_2;
}
function ImagePreview$render$slambda_6() {
  var i = new (ImagePreview$render$slambda_5())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ImagePreview$render$slambdaClass_3;
function ImagePreview$render$slambda_7() {
  if (ImagePreview$render$slambdaClass_3 === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    ImagePreview$render$slambdaClass_3 = $;
  }
  return ImagePreview$render$slambdaClass_3;
}
function ImagePreview$render$slambda_8() {
  var i = new (ImagePreview$render$slambda_7())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var ImagePreviewClass;
function ImagePreview() {
  if (ImagePreviewClass === VOID) {
    class $ {
      constructor(images) {
        this.aid_1 = images;
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(ImagePreview$render$slambda_0());
        view.eba(get_viewIsWide(view) ? times(get_AppDimensions().wg1_1, 2) : get_AppDimensions().wg1_1);
        var tmp = view.ibb(view.hbb(ImagePreviewSemantic_getInstance().ybe(DialogSemantic_getInstance())), align(view, Align_Stretch_getInstance(), Align_Stretch_getInstance()));
        // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_0 = new (Frame())(view.pc());
        var tmp0_elvis_lhs_0 = view.cbb_1;
        var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
        view.ebb(p_0, view_0);
        var tmp_0 = get_expanding(view_0);
        // Inline function 'kotlin.apply' call
        var this_0 = new (Recycler2())(view_0, false);
        this_0.tdj(new (RecyclerViewPagingPlacer())());
        this_0.qdj(Align_Center_getInstance());
        this_0.sdj(true);
        this_0.xde(Companion_instance.wde(this.aid_1));
        var tmp_1 = Companion_instance_0;
        var tmp_2 = ImagePreview$render$lambda;
        this_0.vde(tmp_1.ydc(tmp_2, ImagePreview$render$lambda_0));
        // Inline function 'kotlin.with' call
        var $this$with = this_0.bdd_1;
        if (!get_usesTouchscreen(Companion_instance_1)) {
          var tmp_3 = align($this$with, Align_Start_getInstance(), Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.card' call
          var tmp$ret$0 = $this$with.hbb(CardSemantic_getInstance());
          var tmp_4 = $this$with.ibb(tmp_3, tmp$ret$0);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_1 = new (Button())($this$with.pc());
          var tmp0_elvis_lhs_1 = $this$with.cbb_1;
          var p_1 = tmp0_elvis_lhs_1 == null ? $this$with : tmp0_elvis_lhs_1;
          $this$with.ebb(p_1, view_1);
          icon(view_1, Companion_getInstance().acg_1, 'Previous');
          onClick(view_1, VOID, VOID, ImagePreview$render$slambda_2(this_0, this));
          $this$with.fbb(p_1, view_1);
          $this$with.jbb(tmp_4, view_1);
          var tmp_5 = align($this$with, Align_End_getInstance(), Align_Center_getInstance());
          // Inline function 'com.lightningkite.kiteui.views.card' call
          var tmp$ret$4 = $this$with.hbb(CardSemantic_getInstance());
          var tmp_6 = $this$with.ibb(tmp_5, tmp$ret$4);
          // Inline function 'com.lightningkite.kiteui.views.direct.button' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_2 = new (Button())($this$with.pc());
          var tmp0_elvis_lhs_2 = $this$with.cbb_1;
          var p_2 = tmp0_elvis_lhs_2 == null ? $this$with : tmp0_elvis_lhs_2;
          $this$with.ebb(p_2, view_2);
          icon(view_2, Companion_getInstance().zcf_1, 'Next');
          onClick(view_2, VOID, VOID, ImagePreview$render$slambda_4(this_0, this));
          $this$with.fbb(p_2, view_2);
          $this$with.jbb(tmp_6, view_2);
        }
        view_0.jbb(tmp_0, this_0);
        var tmp_7 = get_atTopEnd(view_0);
        // Inline function 'com.lightningkite.kiteui.views.card' call
        var tmp$ret$12 = view_0.hbb(CardSemantic_getInstance());
        var tmp_8 = view_0.ibb(tmp_7, tmp$ret$12);
        // Inline function 'com.lightningkite.kiteui.views.buttonTheme' call
        var tmp$ret$13 = view_0.hbb(ButtonSemantic_getInstance());
        var tmp_9 = view_0.ibb(tmp_8, tmp$ret$13);
        // Inline function 'com.lightningkite.kiteui.views.direct.button' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view_3 = new (Button())(view_0.pc());
        var tmp0_elvis_lhs_3 = view_0.cbb_1;
        var p_3 = tmp0_elvis_lhs_3 == null ? view_0 : tmp0_elvis_lhs_3;
        view_0.ebb(p_3, view_3);
        view_3.jbb(get_centered(view_3), icon(view_3, resize(Companion_getInstance().tcf_1, get_rem(2)), 'Close Preview'));
        onClick(view_3, VOID, VOID, ImagePreview$render$slambda_6());
        view_0.fbb(p_3, view_3);
        view_0.jbb(tmp_9, view_3);
        view.fbb(p_0, view_0);
        view.jbb(tmp, view_0);
        view.tbo(ImagePreview$render$slambda_8());
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'ImagePreview', VOID, VOID, [Page()]);
    ImagePreviewClass = $;
  }
  return ImagePreviewClass;
}
//region block: exports
export {
  ImagePreview as ImagePreview2jehuxn8wua45,
};
//endregion

//# sourceMappingURL=ImagePreview.mjs.map
